var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCkeckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.98956,7.95863a.39386.39386,0,0,0-.5762,0l-6.58925,6.58909L7.56835,11.29211a.39387.39387,0,0,0-.57619,0l-.62616.62616a.39386.39386,0,0,0,0,.5762l4.17,4.17017a.394.394,0,0,0,.57605,0l7.50366-7.5035a.39472.39472,0,0,0,0-.57635Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCkeckbox);
export default __webpack_public_path__ + "static/media/ckeckbox.07597d3e5b159f415d286667e45ecb32.svg";
export { ForwardRef as ReactComponent };